import React from 'react';
import Dropzone from 'react-dropzone';
import { Button } from 'reactstrap';

const ImageDropzone = ({ imageUrl, onDrop, onClear, name }) => (
    <Dropzone accept="image/*" onDrop={onDrop}>
        {({ getRootProps, getInputProps }) => (
            <div className="dropzone">
                <div className="dz-message needsclick" {...getRootProps()}>
                    <input {...getInputProps()} />
                    {imageUrl ? (
                        <img src={imageUrl} className="preview-img" alt="" />
                    ) : (
                        <i className="h1 text-muted dripicons-cloud-upload upload-icon" />
                    )}
                    <p className="text-muted dropzone-text">Drop {name} here or click to browse</p>
                    <Button type="button" color="primary">Browse</Button>
                    {imageUrl && onClear && (
                        <Button
                            type="button"
                            color="danger"
                            className="ml-2"
                            onClick={(e) => { e.stopPropagation(); onClear(); }}
                        >
                            Remove
                        </Button>
                    )}
                </div>
            </div>
        )}
    </Dropzone>
);

export default ImageDropzone;
